import React from 'react';

import styled from 'styled-components';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';

import Wrapper from '../Wrapper';
import { Row } from '../Container';
import Image from '../Image';
import Button from '../Button';
import { Text } from '../Text';
import GuestRating from '../GuestRating';
import hotelCardWithRoomProptypes from './HotelCardWithRoom.proptypes';

const HotelCardWithRoomContainer = styled(Wrapper)`
  padding: 0;
  margin: 0;
  width: 100%;
  max-height: 130px;
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
`;

const HotelCardWithRoomTopContent = styled(Row)`
  height: 65px;
  width: 100%;
  background: #ffffff;
  border-radius: 4px;
`;

const Thumbnail = styled(Image)`
  max-width: 60px;
  max-height: 64px;
  border-radius: 4px 0px 0px 0px;
`;

const HotelDetailsContainer = styled(Wrapper)`
  flex-direction: column;
  padding: 14px 12px;
  width: 100%;
`;

const RatingContainer = styled(Wrapper)`
  flex-direction: row;
  ${({ tripAdvisorRatingUrl }) =>
    tripAdvisorRatingUrl
      ? `
      margin-left: -6px;
    `
      : `margin-top: -8px; 
        `}
`;

const HotelName = styled(Text)`
  font-size: 14px;
  line-height: 21px;
`;

const Divider = styled(Wrapper)`
  padding: 0;
  margin: 0;
  width: 100%;
  border-bottom: 1px solid #f8f8f8;
`;

const ButtonContainer = styled(Row)`
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

const HotelCardWithRoom = ({
  image,
  name,
  guestRating,
  guestRatingLabel,
  guestRatingCount,
  tripAdvisorRatingUrl,
  onClickSelectRoom,
  move,
}) => {
  return (
    <HotelCardWithRoomContainer>
      <HotelCardWithRoomTopContent>
        <Thumbnail src={image} />
        <HotelDetailsContainer>
          <HotelName numberOfLines={1}>{name}</HotelName>
          <RatingContainer tripAdvisorRatingUrl={tripAdvisorRatingUrl}>
            {tripAdvisorRatingUrl ? (
              <Image height="16px" width="104px" src={tripAdvisorRatingUrl} />
            ) : (
              guestRating > 0 &&
              guestRatingCount > 0 && (
                <GuestRating
                  showInline
                  width="100%"
                  rating={guestRating}
                  ratingLabel={guestRatingLabel}
                  reviewCount={guestRatingCount}
                  move={move}
                />
              )
            )}
          </RatingContainer>
        </HotelDetailsContainer>
      </HotelCardWithRoomTopContent>
      <Divider />
      <ButtonContainer>
        <Button
          secondary
          block
          onClick={onClickSelectRoom}
          move
          border={move && '#023C40'}
          borderRadius={move && '32px'}
          hovercolor={move && '#E8F2EC'}
        >
          {translate('roomCard.selectRoom')}
        </Button>
      </ButtonContainer>
    </HotelCardWithRoomContainer>
  );
};

HotelCardWithRoom.propTypes = hotelCardWithRoomProptypes;

export default HotelCardWithRoom;
